import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import { OffboardingService } from '../services/offboarding.service';
import { OffboardingPermissions, OffboardingQueue } from '../models/offboarding.model';

const ACTIVE = {queue: <OffboardingQueue>'ACTIVE', limit: 1, offset: 0, refreshMs: 60000, cursorType: 'number'};

@Directive({selector: '[appWorkflowMenu]', exportAs: 'workflowMenu'})
export class WorkflowMenuDirective implements OnInit, OnDestroy {
  @Input() watchActiveOffboarding = false;
  canViewOffboarding = false;
  hasActiveOffboarding = false;
  private destroy$ = new Subject<void>();

  constructor(private api: OffboardingService, private router: Router) {}

  ngOnInit(): void {
    this.router.events.filter(event => event instanceof NavigationEnd).startWith(null)
      .switchMap(() => this.refreshPermissions())
      .takeUntil(this.destroy$).subscribe(active => this.hasActiveOffboarding = active);
  }

  private refreshPermissions(): Observable<boolean> {
    return this.api.permissions().catch(() => Observable.of<OffboardingPermissions>(null))
      .switchMap(permissions => this.activity(permissions));
  }

  private activity(permissions: OffboardingPermissions): Observable<boolean> {
    this.canViewOffboarding = !!permissions && permissions.canViewOffboarding === true;
    if (!this.watchActiveOffboarding || !this.canViewOffboarding) { return Observable.of(false); }
    return Observable.merge(Observable.of(null), Observable.interval(ACTIVE.refreshMs), this.api.caseChanges)
      .switchMap(() => this.activeCase(ACTIVE.offset).catch(() => Observable.of(false)));
  }

  private activeCase(offset: number): Observable<boolean> {
    return this.api.search(offset, ACTIVE.queue, ACTIVE.limit).switchMap(page => {
      if (!page || page.queue !== ACTIVE.queue) { return Observable.of(false); }
      if ((page.items || []).length) { return Observable.of(true); }
      if (page.hasMore && typeof page.nextOffset === ACTIVE.cursorType && page.nextOffset > offset) {
        return this.activeCase(page.nextOffset);
      }
      return Observable.of(false);
    });
  }

  ngOnDestroy(): void { this.destroy$.next(); this.destroy$.complete(); }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/navbar/workflow-menu.directive.ts